var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcPhone(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "a",
    d: "M18.863 13.603a9.006 9.006 0 01-2.137-.493c-.904-.33-1.89-.083-2.63.575l-.575.575c-1.48-.986-2.795-2.219-3.781-3.78l.575-.576c.658-.657.904-1.726.575-2.63a9.006 9.006 0 01-.493-2.137C10.233 3.904 9.164 3 7.932 3H5.219a2.54 2.54 0 00-1.644.904C3.165 4.397 3 5.054 3 5.712c.247 2.63 1.233 5.26 2.63 7.48a17.283 17.283 0 005.178 5.178c2.22 1.48 4.85 2.383 7.48 2.63h.246c.658 0 1.315-.247 1.726-.74.411-.493.74-1.068.74-1.726v-2.466c0-1.232-.904-2.3-2.137-2.465zm.493 2.465v2.466a.746.746 0 01-.246.576c-.165.164-.33.246-.658.246-2.384-.246-4.685-1.068-6.74-2.383-1.89-1.151-3.452-2.795-4.685-4.685-1.315-2.055-2.137-4.356-2.383-6.74 0-.247.082-.411.164-.575.165-.165.411-.33.658-.33h2.466c.41 0 .74.33.821.74a8.46 8.46 0 00.658 2.466c.082.33 0 .658-.164.904l-1.069.987a.874.874 0 00-.164.986 13.487 13.487 0 005.26 5.26c.329.165.74.165.986-.164l1.069-1.069c.246-.246.575-.328.904-.164.822.329 1.644.493 2.466.658.328.082.657.41.657.821z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#BDBDBD",
    mask: "url(#b)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcPhone);
export default __webpack_public_path__ + "static/media/ic-phone.969bcb4251a0d665c8001cfd44dd5863.svg";
export { ForwardRef as ReactComponent };